import { Card, Typography, Grid, Divider, Box, CardContent, Stack, Avatar, ListItemAvatar, List, ListItem, ListItemText, TextField, Tooltip, Menu } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AngleRightIcon from 'common/customIcons/angle_right';
import colors from 'assets/theme/base/colors';
import productImage from 'assets/images/placeholder-image.png';
import moment from 'moment';
import { formatTimestampToDateView } from 'utilities/common';
import { addSpaceBeforeCapital } from 'utilities/common';
import Zoom from 'react-medium-image-zoom';
import InActiveIcon from 'common/customIcons/inactive';
import DeliveredIcon from 'common/customIcons/delivered';
import ReturnApprovedIcon from 'common/customIcons/returnApproved';
import ReturnRequestIcon from 'common/customIcons/returnRequest';
import InProgressIcon from 'common/customIcons/inprogress';
import { orderDetailStatus } from 'utilities/common';
import { returnRequestStatus } from 'utilities/common';
import { fetchMemberOrdersByCuid, getMemberDetailsbyEmail, updateMember } from '../../../../redux/slices/hyperwolf/members';
import dayjs from 'dayjs';
import { formatBlazePhoneNumber } from 'utilities/common';
import MDButton from 'components/MDButton';
import { openSnackbar } from '../../../../redux/slices/common';
import { isEmptyObject } from 'utilities/common';
import EditIcon from 'common/customIcons/edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { openCustomModalDialog } from '../../../../redux/slices/modalSlice';
import { Memberguest } from 'common/memberBadges';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { getData } from 'utilities/common';

export default function HyperwolfMemberDetails() {
  const { grey } = colors;
  const { memberEmail } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { memberDetails = {}, memberOrderDetails: Details = {}, loading = false } = useSelector(state => state?.hyperwolfMemberSlice) || {};
  const [cuid, setCuid] = useState('');
  const {
    created,
    address = {},
    dob,
    email,
    firstName,
    consumerType,
    marketingSource,
    sex,
    idImage,
    memberGroup,
    cpn,
    selfiePhotoUrl = '', guestCheckout,

    blockOnlinePayments = {}
  } = memberDetails?.memberDetail || {};

  const [formData, setFormData] = useState({
    blockOnlinePayments: {
      status: false,
      blockedReason: ""
    }
  })

  const [errors, setErrors] = useState({});
  const values = Details?.Details?.values || [];
  const itemsArray = values[0]?.cart?.items;
  const { user } = useSelector(state => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const orderStatusColor = {
    'delivered': '#04B072',
    'approved': '#24CA49',
    'return_request': '#000000',
    'cancelled': '#FD4438',
    'rejected': '#FD4438',
    'awaiting_shipment': '#8E0CF5',
    'shipped': '#24CA49',
  };

  const orderStatusIcons = {
    'delivered': <DeliveredIcon width='18px' height='18px' flex='none' />,
    'approved': <ReturnApprovedIcon width='18px' height='18px' flex='none' />,
    'return_request': <ReturnRequestIcon width='18px' height='18px' flex='none' />,
    'cancelled': <InActiveIcon width='18px' height='18px' flex='none' />,
    'awaiting_shipment': <InProgressIcon width='18px' height='18px' flex='none' />,
    'rejected': <InActiveIcon width='18px' height='18px' flex='none' />,
  };


  useEffect(() => {
    if (memberEmail) {
      dispatch(getMemberDetailsbyEmail(memberEmail)).unwrap().then(
        res => {
          setCuid(res?.memberDetail.consumerUserId);
        }
      );
    }
  }, [memberEmail]);

  useEffect(() => {
    if (cuid?.length) {
      dispatch(fetchMemberOrdersByCuid({ cuid, filters: { start: 0, limit: 10 } }));
    }
  }, [cuid]);


  const handleToggleBlock = () => {
    // open modal//
    if (formData?.blockOnlinePayments?.status) {
      dispatch(openCustomModalDialog({
        modal: 'ACTIVE_CARD',
        modalData: {
          memberEmail,
          platform: "hw"
        }
      }))
    }

    // modal end//

  };
  const handleClick = (event) => {
    if (!(formData?.blockOnlinePayments?.status && formData?.blockOnlinePayments?.blockedReason)) {
      setAnchorEl(event.currentTarget);
      setFormData((prevData) => ({
        ...prevData,
        blockOnlinePayments: {
          status: true,
          blockedReason: formData?.blockOnlinePayments?.blockedReason,
        },
      }));
    }
  };



  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };
  useEffect(() => {
    if (!isEmptyObject(memberDetails?.memberDetail)) {
      let payload = {
        ...memberDetails?.memberDetail, address: memberDetails?.memberDetail?.address?.address, dob: memberDetails?.memberDetail?.dob ? dayjs(memberDetails?.memberDetail?.dob) : '', status: memberDetails?.memberDetail?.status ? 'active' : 'inactive'
      }

      setFormData({ ...payload, createdBy: user?.name });
      if (memberDetails?.memberDetail?.deliveryAddress?.zipcode) {
        setFormData({ ...payload, zipcode: memberDetails?.memberDetail?.deliveryAddress?.zipcode, createdBy: user?.name });
      }
    }
  }, [memberDetails?.memberDetail]);

  useEffect(() => {
    setFormData({ ...formData, createdBy: user?.name });
  }, [user?.name]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let payload = {

    };

    // Check if blockedReason is empty or just whitespace
    if (!formData?.blockOnlinePayments?.blockedReason || formData?.blockOnlinePayments?.blockedReason.trim() === '') {
      // Set the error for blockedReason
      setErrors({ blockedReason: 'A block reason is required when blocking payments.' });

      return; // Stop further submission
    } else {
      // Reset errors if blockedReason is valid
      setErrors({});
    }

    payload = {
      email: formData.email,
      blockOnlinePayments: {
        status: formData?.blockOnlinePayments?.status,
        blockedReason: formData?.blockOnlinePayments?.blockedReason,
        blockedDate: new Date().valueOf(),
        blockedBy: user?.name
      }
    }

    dispatch(updateMember({ email: memberEmail, data: payload })).unwrap()
      .then((res) => {
        setAnchorEl(false)
        showError(res?.message, 'success');
        // navigate('/hyperwolf/members');
        dispatch(getMemberDetailsbyEmail(memberEmail)).unwrap().then(
          res => {
            setCuid(res?.memberDetail.consumerUserId);
          }
        );
      }).catch((err) => {
        showError(err?.message, 'error');
      });


  };

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Members", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Members", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Members", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Members", "Delete");

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} mb={3.5}>
          <Box onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }} display='flex' alignItems='center' color='text.main' lineHeight={1}>
            <AngleRightIcon fontSize='14px' />
            <Typography variant='h6' fontWeight='semibold' ml={.75}>Members</Typography>
          </Box>

          <Box display='flex' alignItems='center' gap={1.25}>
            {memberEmail &&
              (
                <Box display='flex' alignItems='center' gap={2.5}>
                  <Typography variant='h5' fontWeight='semibold' color='secondary'>Online Payment:</Typography>
                  <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#ffffff">
                    <MDButton
                      sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                      type='button'
                      variant={formData?.blockOnlinePayments?.status !== true ? 'contained' : 'text'}
                      color={formData?.blockOnlinePayments?.status !== true ? 'success' : 'dark'}
                      size="small"
                      // onClick={handleToggleBlock}
                      onClick={(e) => canEdit ? handleToggleBlock(e) : ""}
                      style={{ cursor: formData?.blockOnlinePayments?.status !== true ? "auto" : "pointer" }}

                    >
                      Active
                    </MDButton>
                    <MDButton
                      sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                      type='button'
                      variant={formData?.blockOnlinePayments?.status === true ? 'contained' : 'text'}
                      color={formData?.blockOnlinePayments?.status === true ? 'error' : 'dark'}
                      size="small"
                      // onClick={handleClick}
                      onClick={(e) => canEdit ? handleClick(e) : ""}
                      style={{ cursor: formData?.blockOnlinePayments?.status === true ? "auto" : "pointer" }}
                    >
                      Block
                    </MDButton>
                  </Stack>

                  {
                    (formData?.blockOnlinePayments?.status && formData?.blockOnlinePayments?.blockedReason) && <Tooltip title={formData?.blockOnlinePayments?.blockedReason}>
                      <InfoOutlinedIcon color='#656575' style={{ marginLeft: "-15px", marginRight: "10px" }} />
                    </Tooltip>
                  }

                  {(anchorEl) &&
                    <Menu
                      id="block-member-menu"
                      anchorEl={anchorEl}
                      open={open}
                      // onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        className: 'popover-block-member hyperwolf-block-member'
                      }}
                    >
                      <Box display='flex' gap={1.25} flexDirection='column'>
                        <Typography variant='h5' fontWeight='semibold' color='#2E2E3A' style={{ fontSize: '16px' }}>Add Reason</Typography>
                        <Box>
                          <TextField
                            className="form-input"
                            name='memo'
                            value={formData?.blockOnlinePayments?.blockedReason || ''}
                            error={Boolean(errors?.blockedReason)} helperText={errors?.blockedReason}
                            onChange={(e) => {
                              const newBlockedReason = e.target.value;
                              setFormData((prevFormData) => ({
                                ...prevFormData,
                                blockOnlinePayments: {
                                  ...prevFormData.blockOnlinePayments,
                                  blockedReason: newBlockedReason, // Update blockedReason in formData
                                },
                              }));
                            }}
                            fullWidth
                            multiline
                            rows={4}
                            variant='outlined'
                            label="Block Reason"
                          />
                        </Box>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='end' spacing={1.25}>
                          <MDButton
                            sx={{ minWidth: '120px' }}
                            type='button'
                            variant='outlined'
                            color='dark'
                            size="small"
                            onClick={() => { setAnchorEl(false); dispatch(getMemberDetailsbyEmail(memberEmail)) }}
                          >
                            Cancel
                          </MDButton>
                          <MDButton
                            sx={{ minWidth: '120px' }}
                            type='button'
                            variant='contained'
                            color='primary'
                            onClick={handleSubmit}
                            disabled={loading}
                            loading={loading}
                            size="small"
                          >Save</MDButton>
                        </Stack>
                      </Box>
                    </Menu>
                  }
                </Box>
              )
            }

            {/* <Box>
                <MDButton
                  sx={{ minWidth: '220px' }}
                  type='button'
                  variant='contained'
                  color='primary'
                  className="gap-2"
                  style={{ fontWeight: "500", padding: "5px 20px" }}
                  onClick={() => dispatch(openCustomDrawer({ drawer: 'WALLET', drawerData: memberDetails }))}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                    <path d="M11.125 1.625H1.875C0.841115 1.625 0 2.46612 0 3.5V10.5C0 11.5339 0.841115 12.375 1.875 12.375H11.125C12.1589 12.375 13 11.5339 13 10.5V3.5C13 2.46612 12.1589 1.625 11.125 1.625ZM12.25 8.125H9.5C8.87969 8.125 8.375 7.62034 8.375 6.99999C8.375 6.37965 8.87966 5.87498 9.5 5.87498H12.25V8.125ZM12.25 5.125H9.5C8.46612 5.125 7.62501 5.96611 7.62501 6.99999C7.62501 8.03387 8.46612 8.87499 9.5 8.87499H12.25V10.5C12.25 11.1203 11.7453 11.625 11.125 11.625H1.875C1.25468 11.625 0.749988 11.1203 0.749988 10.5V3.5C0.749988 2.87968 1.25465 2.37499 1.875 2.37499H11.125C11.7453 2.37499 12.25 2.87965 12.25 3.5V5.125Z" fill="white" />
                    <path d="M9.99999 6.625H9.49999C9.29288 6.625 9.125 6.79291 9.125 6.99999C9.125 7.20711 9.29291 7.37499 9.49999 7.37499H9.99999C10.2071 7.37499 10.375 7.20708 10.375 6.99999C10.375 6.79288 10.2071 6.625 9.99999 6.625Z" fill="white" />
                  </svg>
                  <span>Wallet Balance - </span>
                  <span>{`$${formData?.walletAmount ? formData?.walletAmount :"0"}`}</span>
                </MDButton>
              </Box> */}
          </Box>
        </Stack>

        <Grid container spacing={2.5} mb={4}>
          <Grid item xs={12} lg={7}>
            <Card variant='detailsCard' sx={{ height: '100%', overflow: 'hidden' }}>
              <CardContent sx={{ p: { xs: 2, md: 3.5 }, pb: 0 }}>

                {blockOnlinePayments?.status &&
                  <Box display="flex" alignItems="center" justifyContent="center" mb={1} style={{ backgroundColor: "#FF7F7F", color: "#ffffff", margin: "-28px -28px 28px -28px", fontSize: "16px", padding: "6px 0", fontWeight: "700" }}>
                    {blockOnlinePayments?.status ? 'Card Blocked' : ''}
                  </Box>
                }

                <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={3} mb={3}>
                  <Typography variant='h5'>Member Details</Typography>
                  {/* <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>

                    <MDButton
                      type='button'
                      variant='outlined'
                      color='dark'
                      size="small"
                      startIcon={<EditIcon width='15px' height='15px' />}
                      sx={{ borderRadius: 1.5 }}
                      onClick={() => navigate(`/hyperwolf/members/${memberEmail}`)}
                      style={{ minWidth: "90px", minHeight: "34px" }}
                    >
                      Edit
                    </MDButton>

                  </Stack> */}
                </Stack>


                <Stack direction='row' spacing={1.25} mb={4}>
                  <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: '20px', width: '108px', height: '108px', objectFit: 'contain' }} src={idImage || productImage} alt='Product Name' /></Zoom>
                </Stack>

                <Grid container alignItems='center' spacing={2} mb={1}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Name</Typography>
                    <Typography variant='h6' fontWeight='medium' sx={{ textTransform: 'capitalize' }}>{firstName?.toLowerCase() || '-'} {guestCheckout && <Memberguest />}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Email</Typography>
                    <Typography variant='h6' fontWeight='medium'>{email}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Age</Typography>
                    <Typography variant='h6' fontWeight='medium'>{dayjs().diff(dayjs(dob), 'year')}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Gender</Typography>
                    <Typography variant='h6' fontWeight='medium' sx={{ textTransform: 'capitalize' }}>{sex === 1 ? 'Male' : sex === 2 ? 'Female' : 'Others'}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>DOB</Typography>
                    <Typography variant='h6' fontWeight='medium'>{dob ? moment(dob).format('MM/DD/YYYY') : '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Phone</Typography>
                    <Typography variant='h6' fontWeight='medium'>{cpn ? formatBlazePhoneNumber(cpn) : '-'}</Typography>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Member ID</Typography>
                    <Typography variant='h6' fontWeight='medium'>{memberEmail}</Typography>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Member Type</Typography>
                    <Typography variant='h6' fontWeight='medium'>{consumerType ? addSpaceBeforeCapital(consumerType) : '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Member Group</Typography>
                    <Typography variant='h6' fontWeight='medium'>{memberGroup ? addSpaceBeforeCapital(memberGroup.name) : '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Source</Typography>
                    <Typography variant='h6' fontWeight='medium'>{marketingSource}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]}>Created on</Typography>
                    <Typography variant='h6' fontWeight='medium'>{created ? formatTimestampToDateView(created) : '-'}</Typography>
                  </Grid>
                  {blockOnlinePayments?.status &&
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Card Blocked Reason</Typography>
                      <Typography variant='h6' fontWeight="medium">{blockOnlinePayments?.blockedReason || ''}</Typography>
                    </Grid>
                  }
                  {
                    memberDetails?.memberDetail?.recId && <Grid item xs={12} md={6}>
                      <Typography variant='caption' color={grey[600]}>Rec ID</Typography>
                      <Link to={memberDetails?.memberDetail?.recId}>
                        <a target='_blank'>
                          <Typography variant='h6' fontWeight='medium' lineHeight='1.25'>{memberDetails?.memberDetail?.recId || '-'}</Typography>
                        </a>
                      </Link>
                    </Grid>
                  }

                  <Grid item xs={12} mt={2}>
                    <Typography variant='body2' fontWeight='semibold' mb={1} color={grey[600]}>Member Address</Typography>
                    <Typography variant='h6' fontWeight='regular' lineHeight='1.85'>
                      {
                        address?.address?.apartment && <>
                          <b style={{ fontWeight: 600 }}>Apartment Number: </b>{address.address.apartment || '-'} <br />
                        </>
                      }
                      <b style={{ fontWeight: 600 }}>Address: </b>{address.address} <br />
                      <b style={{ fontWeight: 600 }}>City: </b>{address.city} <br />
                      <b style={{ fontWeight: 600 }}>State: </b>{address.state} <br />
                      <b style={{ fontWeight: 600 }}>Zip Code: </b>{address.zipCode}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <div className='cus-img-full-sec mt-0'>
                      {selfiePhotoUrl &&
                        <div className='cus-image-half'>
                          <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "100%", maxWidth: "100%", objectFit: "contain", maxHeight: "300px" }} src={selfiePhotoUrl || productImage} alt="No Image Found" /></Zoom>
                        </div>
                      }
                      <div className='cus-image-half'>
                        <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "100%", maxWidth: "100%", objectFit: "contain", maxHeight: "300px" }} src={idImage || productImage} alt="No Image Found" /></Zoom>
                      </div>
                    </div>
                  </Grid>
                  {/* <Grid className='cus-image-full' p={3} style={{ margin: "auto" }}>
                    <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "100%", maxWidth: "100%", objectFit: "contain", maxHeight: "300px" }} src={idImage || productImage} alt="No Image Found" /></Zoom>
                  </Grid> */}
                  {/* <Grid item xs={12} mt={2}>
                    {memberEmail &&
                      (<Box mb={2}>
                        <Typography variant='h5' fontWeight="semibold" mb={1.5}>Online Payment Status</Typography>

                        <Box display="flex" alignItems="center" gap={1.25} mb={2}>
                          <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#F2F3F7">
                            <MDButton
                              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                              type='button'
                              variant={isBlock !== true ? 'contained' : 'text'}
                              color={isBlock !== true ? 'success' : 'dark'}
                              size="small"
                              onClick={handleToggleBlock}
                            >
                              Active
                            </MDButton>
                            <MDButton
                              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                              type='button'
                              variant={isBlock === true ? 'contained' : 'text'}
                              color={isBlock === true ? 'error' : 'dark'}
                              size="small"
                              onClick={handleToggleBlock}
                            >
                              Block
                            </MDButton>
                          </Stack>

                        </Box>
                        {( isBlock)
                          &&
                          <Grid item xs={12}>
                            <TextField className="form-input" name='blockedReason' value={formData?.blockOnlinePayments?.blockedReason || ''} error={Boolean(errors?.blockedReason)} helperText={errors?.blockedReason}
                              onChange={(e) => {
                                const newBlockedReason = e.target.value;
                                setBlockReason(newBlockedReason); // Update the local blockedReason state
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  blockOnlinePayments: {
                                    ...prevFormData.blockOnlinePayments,
                                    blockedReason: newBlockedReason, // Update blockedReason in formData
                                  },
                                }));
                              }}
                              disabled={!isBlock}
                              fullWidth label="Block Reason" />
                          </Grid>
                        }
                      </Box>
                      )
                    }

                    <MDButton
                      sx={{ minWidth: '140px' }}
                      type='button'
                      variant='contained'
                      color='primary'
                      onClick={handleSubmit}
                      disabled={loading}
                      loading={loading}

                    >
                      {memberEmail ? 'Update' : 'Save'}
                    </MDButton>
                  </Grid> */}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} lg={5}>
            <Card variant='detailsCard' sx={{ height: '100%', overflow: 'hidden', rowGap: '20px', p: { xs: 2, md: 3.5 } }}>
              <CardContent sx={{ px: 0, pt: 0, pb: { xs: 2, md: 3 }, mb: '-20px' }}>
                <Stack justifyContent='space-between' direction='row' alignItems='center'>
                  <Typography variant='h5'>Recent Orders</Typography>
                </Stack>
              </CardContent>
              {
                values?.length > 0 ? values?.slice(0, 4)?.map((orders => {
                  const { orderPlacedTime, orderNo } = orders;
                  return <CardContent key={orderNo} sx={{ backgroundColor: '#F5F5F5', p: 0, overflow: 'hidden', borderRadius: 2, borderWidth: 1, borderStyle: 'solid', borderColor: orders?.returnRequestStatus && !orders?.warrantyStatus ? orderStatusColor['return_request'] : orders?.returnRequestStatus && orders?.warrantyStatus ? orderStatusColor[orders?.warrantyStatus] : orderStatusColor[orders?.emailStatus] }} style={{ paddingBottom: 0 }}>
                    {
                      !orders?.returnRequestStatus && !orders?.warrantyStatus !== 'rejected' && <>
                        <Box backgroundColor={orderStatusColor[orders?.emailStatus]} color='#fff' display='flex' alignItems='center' justifyContent='center' p={0.5}>
                          {
                            orderStatusIcons[orders?.emailStatus]
                          }
                          <Typography variant='caption' fontWeight='medium' ml={.5} textTransform='capitalize'>{orderDetailStatus?.find((item => item?.key === orders?.emailStatus))?.value}</Typography>
                        </Box>

                      </>
                    }
                    {
                      orders?.returnRequestStatus && orders?.warrantyStatus && <Box backgroundColor={orderStatusColor[orders?.warrantyStatus]} color='#fff' display='flex' alignItems='center' justifyContent='center' p={0.5}>
                        {
                          orderStatusIcons[orders?.warrantyStatus]
                        }
                        <Typography variant='caption' fontWeight='medium' ml={.5} textTransform='capitalize'>Return {returnRequestStatus?.find((item => item?.key === orders?.warrantyStatus))?.value}</Typography>
                      </Box>
                    }
                    {
                      orders?.returnRequestStatus && !orders?.warrantyStatus && <Box backgroundColor={orderStatusColor['return_request']} color='#fff' display='flex' alignItems='center' justifyContent='center' p={0.5}>
                        {
                          orderStatusIcons['return_request']
                        }
                        <Typography variant='caption' fontWeight='medium' ml={.5} textTransform='capitalize'>Return Request</Typography>
                      </Box>
                    }
                    <Box px={3} pt={2} pb={2.5}>
                      <Stack direction={{ xs: 'column', md: 'row' }} alignItems='center' justifyContent='space-between' flexWrap='wrap'>
                        <Typography variant='body2' fontWeight='semibold' mr={2}>#{orderNo}</Typography>
                        <Typography variant='body2' fontWeight='medium'>{orderPlacedTime ? formatTimestampToDateView(orderPlacedTime) : '-'}</Typography>
                      </Stack>
                      <Divider />
                      <List>
                        {
                          itemsArray.map((item => {
                            return <>
                              <ListItem key={item.productId} alignItems='center' sx={{ mt: 2.5 }}>
                                <ListItemAvatar sx={{ mr: 1.5 }} className='pro-avatar-sec'>
                                  <Avatar
                                    alt='Product Name'
                                    src={item.product?.assets[0]?.thumbURL}
                                    sx={{ width: 82, height: 82, borderRadius: 4 }}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={
                                    <React.Fragment>
                                      <Typography variant='body2' fontWeight='medium' color={grey[600]}>{item.brandName || '-'}</Typography>
                                      <Typography variant='h6' fontWeight='medium'>{item.productName || '-'}</Typography>
                                    </React.Fragment>
                                  }
                                  secondary={
                                    <React.Fragment>
                                      <Typography variant='h6' fontWeight='medium' mt={1}>x{item.quantity}</Typography>
                                    </React.Fragment>
                                  }
                                />

                              </ListItem>
                              <Divider />
                            </>;
                          }))
                        }
                      </List>
                    </Box>
                  </CardContent>;

                })) : <Box height={'100%'} width='100%' display='flex' justifyContent='center' alignItems='center'>
                  <Typography variant='body2'>No Orders Found</Typography>
                </Box>
              }
            </Card>
          </Grid>
        </Grid>
      </Box>
    </CommonLayout>
  );
}